import { inject, isDevMode, provideAppInitializer } from '@angular/core';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';

import { TranslocoHttpLoader } from './transloco-loader';

export const translocoProviders = [
  provideTransloco({
    config: {
      availableLangs: ['pt-BR', 'en'],
      defaultLang: 'pt-BR',
      fallbackLang: 'pt-BR',
      reRenderOnLangChange: true,
      prodMode: !isDevMode(),
    },
    loader: TranslocoHttpLoader,
  }),
  provideAppInitializer(() => {
    const transloco = inject(TranslocoService);
    const lang = transloco.getDefaultLang();
    transloco.setActiveLang(lang);
    return firstValueFrom(transloco.load(lang));
  }),
];
